import AssignToFolder from "./AssignToFolder";

export default AssignToFolder;
